import { useQuery } from 'react-query';

import { useRequest, type QueryFunction } from '../common';
import { getDispatchListKey } from './keys';

// Get the full list of dispatches for an event
export const useDispatchList: QueryFunction<
  unknown,
  [eventUuid: string],
  ReturnType<typeof getDispatchListKey>
> = (eventUuid, { query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getDispatchListKey(eventUuid, query),
    queryFn: ({ signal }) =>
      request(`/events/${eventUuid}/dispatches`, {
        init: {
          signal,
        },
        query,
      }),
  });
};

export default {
  useDispatchList,
};
